module.exports = __webpack_public_path__ + "static/media/sf.5092c1c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/sf.png
// module id = 189
// module chunks = 0